class GiftOptions extends HTMLElement {
  constructor() {
    super()

    this.selectedGifts = {
      wrap: null,
      card: null,
      bag: null
    }

    this.engraving = null
    this.lastFocusedElement = null
  }

  connectedCallback() {
    if (this.initialized) return
    this.initialized = true

    this.modal =
      this.querySelector('[data-gift-modal]')

    this.summary =
      this.querySelector('[data-gift-summary]')

    this.summaryItems =
      this.querySelector('[data-gift-summary-items]')

    this.bindEvents()
    this.render()
  }


  bindEvents() {
    this.querySelectorAll('[data-gift-open]').forEach((button) => {
      button.addEventListener('click', () => {
        this.openModal()
      })
    })


    this.querySelectorAll('[data-gift-close]').forEach((button) => {
      button.addEventListener('click', () => {
        this.closeModal()
      })
    })


    this.querySelectorAll('[data-gift-category]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return

        const category =
          button.dataset.giftCategory

        this.showView(category)
      })
    })


    this.querySelectorAll('[data-gift-back]').forEach((button) => {
      button.addEventListener('click', () => {
        this.showView('selection')
      })
    })


    this.querySelectorAll('[data-gift-finish-category]').forEach((button) => {
      button.addEventListener('click', () => {
        this.showView('selection')
      })
    })


    this.querySelectorAll('[data-gift-option]').forEach((button) => {
      button.addEventListener('click', () => {
        this.toggleGiftOption(button)
      })
    })


    this.querySelectorAll('[data-engraving-save]').forEach((button) => {
      button.addEventListener('click', () => {
        this.saveEngraving()
      })
    })


    const engravingFont =
      this.querySelector('[data-engraving-font]')

    if (engravingFont) {
      engravingFont.addEventListener('change', () => {
        this.updateEngravingPreview()
      })
    }


    this.addEventListener('click', (event) => {
      const removeButton =
        event.target.closest('[data-remove-option]')

      if (!removeButton) return

      const type =
        removeButton.dataset.removeOption

      if (type === 'engraving') {
        this.removeEngraving()
        return
      }

      if (
        Object.prototype.hasOwnProperty.call(
          this.selectedGifts,
          type
        )
      ) {
        this.selectedGifts[type] = null
        this.render()
      }
    })


    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        this.modal &&
        !this.modal.hidden
      ) {
        this.closeModal()
      }
    })
  }


  openModal() {
    if (!this.modal) return

    this.lastFocusedElement =
      document.activeElement

    this.modal.hidden = false

    document.documentElement.classList.add(
      'gift-options-modal-open'
    )

    document.body.classList.add(
      'gift-options-modal-open'
    )

    this.showView('selection')

    const closeButton =
      this.querySelector('.gift-options__close')

    closeButton?.focus()
  }


  closeModal() {
    if (!this.modal) return

    this.modal.hidden = true

    document.documentElement.classList.remove(
      'gift-options-modal-open'
    )

    document.body.classList.remove(
      'gift-options-modal-open'
    )

    if (
      this.lastFocusedElement &&
      typeof this.lastFocusedElement.focus === 'function'
    ) {
      this.lastFocusedElement.focus()
    }
  }


  showView(name) {
    this.querySelectorAll('[data-gift-view]').forEach((view) => {
      view.hidden =
        view.dataset.giftView !== name
    })
  }


  toggleGiftOption(button) {
    const type =
      button.dataset.giftType

    if (!type) return

    const selectedVariantId =
      String(button.dataset.giftVariantId)

    const current =
      this.selectedGifts[type]


    if (
      current &&
      String(current.variantId) === selectedVariantId
    ) {
      this.selectedGifts[type] = null

      this.render()
      return
    }


    this.selectedGifts[type] = {
      type,
      typeLabel:
        button.dataset.giftTypeLabel,

      variantId:
        Number(button.dataset.giftVariantId),

      title:
        button.dataset.giftTitle,

      price:
        button.dataset.giftPrice
    }

    this.render()
  }


  saveEngraving() {
    const detail =
      this.querySelector('[data-engraving-detail]')

    if (!detail) return


    const fontSelect =
      detail.querySelector('[data-engraving-font]')

    const textInput =
      detail.querySelector('[data-engraving-text]')


    const fontStyle =
      fontSelect?.value || ''

    const text =
      textInput?.value.trim() || ''


    if (!fontStyle) {
      alert('Please select an engraving font style.')
      return
    }


    if (!text) {
      alert('Please enter your engraving message.')
      return
    }


    const variantId =
      Number(detail.dataset.engravingVariantId)


    if (!variantId) {
      alert('Engraving product is not configured.')
      return
    }


    this.engraving = {
      type: 'engraving',
      typeLabel: 'Engraving',
      variantId,
      title:
        detail.dataset.engravingTitle ||
        'Custom Engraving',
      price:
        detail.dataset.engravingPrice || '',
      fontStyle,
      text
    }


    this.render()
    this.showView('selection')
  }


  removeEngraving() {
    this.engraving = null

    const fontSelect =
      this.querySelector('[data-engraving-font]')

    const textInput =
      this.querySelector('[data-engraving-text]')

    const preview =
      this.querySelector('[data-engraving-preview]')

    const previewImage =
      this.querySelector(
        '[data-engraving-preview-image]'
      )


    if (fontSelect) {
      fontSelect.value = ''
    }

    if (textInput) {
      textInput.value = ''
    }

    if (preview) {
      preview.hidden = true
    }

    if (previewImage) {
      previewImage.src = ''
    }

    this.render()
  }


  updateEngravingPreview() {
    const fontSelect =
      this.querySelector('[data-engraving-font]')

    const preview =
      this.querySelector('[data-engraving-preview]')

    const previewImage =
      this.querySelector(
        '[data-engraving-preview-image]'
      )


    if (
      !fontSelect ||
      !preview ||
      !previewImage
    ) {
      return
    }


    const selectedOption =
      fontSelect.options[
        fontSelect.selectedIndex
      ]

    const imageUrl =
      selectedOption?.dataset.img


    if (!imageUrl) {
      preview.hidden = true
      previewImage.src = ''
      return
    }


    previewImage.src = imageUrl
    preview.hidden = false
  }


  render() {
    const selectedGiftList =
      this.getSelectedItems()


    this.querySelectorAll('[data-gift-option]').forEach((button) => {
      const type =
        button.dataset.giftType

      const selected =
        this.selectedGifts[type]

      const isSelected =
        selected &&
        String(selected.variantId) ===
          String(button.dataset.giftVariantId)


      button.classList.toggle(
        'is-selected',
        Boolean(isSelected)
      )


      const action =
        button.querySelector(
          '.gift-options__product-action'
        )

      if (
        action &&
        !button.disabled
      ) {
        action.textContent =
          isSelected
            ? 'Added'
            : 'Add'
      }
    })


    Object.keys(this.selectedGifts).forEach((type) => {
      const status =
        this.querySelector(
          `[data-category-status="${type}"]`
        )

      const category =
        this.querySelector(
          `[data-gift-category="${type}"]`
        )

      const hasSelection =
        Boolean(this.selectedGifts[type])


      if (status) {
        status.textContent =
          hasSelection
            ? 'Added'
            : 'Add'
      }


      category?.classList.toggle(
        'has-selection',
        hasSelection
      )
    })


    const engravingStatus =
      this.querySelector(
        '[data-category-status="engraving"]'
      )

    const engravingCategory =
      this.querySelector(
        '[data-gift-category="engraving"]'
      )


    if (
      engravingStatus &&
      !engravingCategory?.disabled
    ) {
      engravingStatus.textContent =
        this.engraving
          ? 'Added'
          : 'Add'
    }


    engravingCategory?.classList.toggle(
      'has-selection',
      Boolean(this.engraving)
    )


    const hasAnything =
      selectedGiftList.length > 0 ||
      Boolean(this.engraving)


    this.classList.toggle(
      'has-selection',
      hasAnything
    )


    if (this.summary) {
      this.summary.hidden =
        !hasAnything
    }


    this.renderSummary()
  }


  renderSummary() {
    if (!this.summaryItems) return

    this.summaryItems.innerHTML = ''


    this.getSelectedItems().forEach((gift) => {
      const item =
        document.createElement('div')

      item.className =
        'gift-options__summary-item'


      const content =
        document.createElement('div')

      content.className =
        'gift-options__summary-copy'


      const label =
        document.createElement('strong')

      label.textContent =
        gift.typeLabel


      const value =
        document.createElement('span')

      value.textContent =
        gift.price
          ? `${gift.title} — ${gift.price}`
          : gift.title


      const remove =
        document.createElement('button')

      remove.type = 'button'

      remove.className =
        'gift-options__remove'

      remove.dataset.removeOption =
        gift.type

      remove.setAttribute(
        'aria-label',
        `Remove ${gift.typeLabel}`
      )

      remove.textContent = '×'


      content.append(
        label,
        value
      )

      item.append(
        content,
        remove
      )

      this.summaryItems.append(item)
    })


    if (this.engraving) {
      const item =
        document.createElement('div')

      item.className =
        'gift-options__summary-item'


      const content =
        document.createElement('div')

      content.className =
        'gift-options__summary-copy'


      const label =
        document.createElement('strong')

      label.textContent =
        'Engraving'


      const value =
        document.createElement('span')

      const price =
        this.engraving.price
          ? ` — ${this.engraving.price}`
          : ''

      value.textContent =
        `${this.engraving.fontStyle}: "${this.engraving.text}"${price}`


      const remove =
        document.createElement('button')

      remove.type = 'button'

      remove.className =
        'gift-options__remove'

      remove.dataset.removeOption =
        'engraving'

      remove.setAttribute(
        'aria-label',
        'Remove engraving'
      )

      remove.textContent = '×'


      content.append(
        label,
        value
      )

      item.append(
        content,
        remove
      )

      this.summaryItems.append(item)
    }
  }


  getSelectedItems() {
    return Object.values(
      this.selectedGifts
    ).filter(Boolean)
  }


  getEngravingSelection() {
    return this.engraving
  }


  hasGiftSelections() {
    return this.getSelectedItems().length > 0
  }


  hasEngravingSelection() {
    return Boolean(this.engraving)
  }


  hasSelections() {
    return (
      this.hasGiftSelections() ||
      this.hasEngravingSelection()
    )
  }


  resetSelections() {
    this.selectedGifts = {
      wrap: null,
      card: null,
      bag: null
    }

    this.removeEngraving()

    this.render()
  }
}


if (!customElements.get('gift-options')) {
  customElements.define(
    'gift-options',
    GiftOptions
  )
}